export const getters = {
  currentPoll: (state) => state.currentPoll,
  choices: (state) => state.currentPoll.options,
  results: (state) => state.entries,
};
